module.exports = __webpack_public_path__ + "dash_20_app_assets/img/avatar-s-7.b00fd0f7.jpg";